import {
    trackEvent,
    eventNameConstants,
    stepInteractionConstants,
    interactionTypeConstants,
} from 'dibs-tracking';

const { EVENT_PRODUCT_INTERACTION } = eventNameConstants;
const { INTERACTION_TYPE_SELLER_REVIEWS } = interactionTypeConstants;
const { STEP_INTERACTION_SELLER_REVIEWS_CLICK } = stepInteractionConstants;

export function orderFeedbackEvent({
    action,
    label,
    count,
}: {
    action: string;
    label: string;
    count?: number;
}): void {
    trackEvent(
        {
            action,
            label,
            category: 'seller reviews',
            isInteractiveEvent: true,
            eventName: EVENT_PRODUCT_INTERACTION,
            interaction_type: INTERACTION_TYPE_SELLER_REVIEWS,
            step_interaction_name: STEP_INTERACTION_SELLER_REVIEWS_CLICK,
            trigger: label,
            step_type: count,
        },
        null
    );
}
